export default {
  //授课问卷
  SKInquiryList: '',
  //问卷详情
  SKInquiryDetails: '',
  //授课编辑
  SKInquiryEdit: '',
}
